(() => {
  const drawer = document.getElementById('vt-mobile-cart');
  if (!drawer) return;
  const content = drawer.querySelector('.vt-drawer-content');
  const mobile = window.matchMedia('(max-width: 900px)');
  let busy = false, previousOverflow = '', opener;
  const lock = value => {
    busy = value;
    document.querySelectorAll('[data-cart-key], .vt-cart-checkout, .vt-upsell-add, #vt-add-btn').forEach(el => { el.disabled = value; });
    drawer.setAttribute('aria-busy', String(value));
  };
  async function refresh() {
    const response = await fetch(drawer.dataset.cartUrl, {headers:{Accept:'text/html'}, cache:'no-store'});
    if (!response.ok) throw new Error('Unable to load your bag. Please try again.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const page = html.querySelector('.vt-cart-page');
    if (!page) throw new Error('Unable to load your bag. Please try again.');
    const fullPage = document.querySelector('body > .vt-cart-page') || document.querySelector('.vt-cart-page');
    if (fullPage && !drawer.contains(fullPage)) fullPage.replaceWith(page.cloneNode(true));
    const inner = page.querySelector('.vt-cart-inner');
    const scroll = document.createElement('div');
    scroll.className = 'vt-drawer-scroll';
    scroll.append(inner.firstElementChild);
    const summary = inner.querySelector('.vt-cart-summary');
    content.replaceChildren(scroll);
    if (summary) {
      const benefits = document.createElement('p');
      benefits.className = 'vt-drawer-benefits';
      benefits.textContent = 'Secure checkout · 30-day returns';
      summary.append(benefits);
      content.append(summary);
    }
    const incoming = html.querySelector('.vt-header-cart');
    const current = document.querySelector('.vt-header-cart');
    if (incoming && current) current.innerHTML = incoming.innerHTML;
  }
  function showError(message) {
    let alert = drawer.open ? content.querySelector('.vt-cart-error') : document.querySelector('.vt-cart-error');
    if (!alert) {
      alert = document.createElement('p'); alert.className = 'vt-drawer-status'; alert.setAttribute('role','alert'); content.prepend(alert);
    }
    alert.textContent = message; alert.hidden = false;
  }
  async function open(trigger) {
    if (busy) return;
    opener = trigger;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    drawer.showModal();
    content.innerHTML = '<p class="vt-drawer-status" role="status">Loading your bag…</p>';
    lock(true);
    try { await refresh(); } catch(error) { showError(error.message); } finally { lock(false); }
  }
  drawer.querySelector('.vt-drawer-close').addEventListener('click', () => drawer.close());
  drawer.addEventListener('close', () => { document.body.style.overflow = previousOverflow; opener?.focus(); });
  drawer.addEventListener('click', event => { if (event.target === drawer) { const rect = drawer.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) drawer.close(); } });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a');
    if (link && mobile.matches && new URL(link.href).pathname.replace(/\/$/,'') === drawer.dataset.cartUrl.replace(/\/$/,'')) {
      event.preventDefault(); if (!drawer.open) await open(link); return;
    }
    const quantity = event.target.closest('[data-cart-key]');
    const remove = event.target.closest('.vt-cart-remove');
    if (!quantity && !remove) return;
    event.preventDefault(); if (busy) return;
    const key = quantity?.dataset.cartKey || remove.closest('.vt-cart-item').querySelector('[data-cart-key]').dataset.cartKey;
    lock(true);
    try {
      const response = await fetch(drawer.dataset.changeUrl + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:quantity ? Math.max(0,Number(quantity.dataset.quantity)) : 0})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag.');
      await refresh();
    } catch(error) { showError(error.message); } finally { lock(false); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.closest('.vt-cart-page, #vt-mobile-cart') && form.id !== 'vt-product-form') return;
    if (busy) { event.preventDefault(); return; }
    const add = form.id === 'vt-product-form' || Boolean(form.querySelector('.vt-upsell-add'));
    if (!add || !mobile.matches) return;
    event.preventDefault();
    const trigger = event.submitter;
    lock(true);
    try {
      const response = await fetch(drawer.dataset.addUrl + '.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
      if (!drawer.open) { lock(false); await open(trigger); } else { await refresh(); }
    } catch(error) { if (!drawer.open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; drawer.showModal(); } showError(error.message); } finally { lock(false); }
  });
  mobile.addEventListener('change', () => { if (!mobile.matches && drawer.open) drawer.close(); });
})();
